// extracted by mini-css-extract-plugin
module.exports = {"oosPopoverWrapper":"Rw","slideIn":"Sw"};